import { useEffect, useState } from "react";
import { Chip } from "./Chips";
import { PlaylistCard, togglePlaylistLike } from "./PlaylistCard";
import { http } from "../lib/api";

export const DiscoverPlaylists = () => {
  const [sort, setSort] = useState("top");
  const [lists, setLists] = useState(null);
  useEffect(() => { http.get("/playlists/discover", { params: { sort } }).then((r) => setLists(r.data)); }, [sort]);

  return (
    <section data-testid="discover-playlists" className="space-y-5">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-[var(--c-violet)] font-semibold">Kūrėjų rinkiniai</p>
          <h2 className="font-display text-base md:text-lg font-bold mt-1">Bendruomenės grojaraščiai</h2>
        </div>
        <div className="flex gap-2">
          <Chip testId="playlists-sort-top" active={sort === "top"} onClick={() => setSort("top")} color="violet">Populiariausi</Chip>
          <Chip testId="playlists-sort-new" active={sort === "new"} onClick={() => setSort("new")} color="violet">Naujausi</Chip>
        </div>
      </div>
      {lists?.length === 0 && (
        <p data-testid="discover-playlists-empty" className="text-sm text-zinc-500 py-8 px-6 rounded-3xl border border-dashed border-[var(--c-line)]">
          Kol kas kiti kūrėjai nepasidalino grojaraščiais.
        </p>
      )}
      <div data-testid="discover-playlists-grid" className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 2xl:grid-cols-6 gap-x-5 gap-y-8">
        {lists?.slice(0, 12).map((pl, i) => (
          <PlaylistCard key={pl.id} pl={pl} index={i} showOwner onLike={(p) => togglePlaylistLike(p, setLists)} />
        ))}
      </div>
    </section>
  );
};
